module.exports = __webpack_public_path__ + "static/media/06_thelovers.c34fda99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/06_thelovers.png
// module id = 69
// module chunks = 0